import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PreviewDrawer } from "@ippon/shared-components";
import ExpenseDetailPage from "@/pages/Expenses/Detail";
import type { ExpenseRecord } from "@/store/expenseSlice";

interface Props {
  open: boolean;
  onClose: () => void;
  expenseId: string | null;
  /** パンくず構築のための物件 ID (全画面遷移時に URL クエリへ付与) */
  propertyId: string;
  /** パンくずに表示する物件名 (全画面遷移時に location.state へ付与) */
  propertyName?: string;
  /** 編集成功時のコールバック (親で予実テーブル等を再取得する用途) */
  onUpdated?: (expenseId: string) => void;
}

/** Notion 風プレビュードロワー: 支出詳細ページをそのまま埋め込み */
const ExpenseDetailDrawer: React.FC<Props> = ({
  open,
  onClose,
  expenseId,
  propertyId,
  propertyName,
  onUpdated,
}) => {
  const navigate = useNavigate();
  const [loadedName, setLoadedName] = useState<string | null>(null);

  useEffect(() => {
    setLoadedName(null);
  }, [expenseId]);

  const handleLoaded = (rec: ExpenseRecord) => {
    setLoadedName(rec.name ?? null);
  };

  const openPage = () => {
    if (!expenseId) return;
    const search = propertyId
      ? `?property_id=${encodeURIComponent(propertyId)}`
      : "";
    navigate(`/expenses/${expenseId}${search}`, {
      state: {
        propName: propertyName,
        title: loadedName,
      },
    });
    onClose();
  };
  return (
    <PreviewDrawer open={open} onClose={onClose} onExpand={openPage}>
      {expenseId && (
        <ExpenseDetailPage
          overrideExpenseId={expenseId}
          embedded
          onUpdated={onUpdated}
          onLoaded={handleLoaded}
        />
      )}
    </PreviewDrawer>
  );
};

export default ExpenseDetailDrawer;
